import { GET_PROFILE, UPDATE_ALL_USER, UPDATE_PROFILE } from '../constants'
//const user = localStorage.getItem('user')
//const userParsed = JSON.parse(user) ? JSON.parse(user) : null
const initial = {
  user: null,
  response: '',
}
export const userReducer = (state = initial, action) => {
  const { type, payload } = action
  switch (type) {
    case UPDATE_PROFILE:
    case GET_PROFILE:
      return {
        ...state,
        user: payload,
      }
    case UPDATE_ALL_USER:
      return {
        ...state,
        user: initial.user?.filter((i) => i._id !== payload.id),
      }
    case 'CANDIDACY':
      return {
        ...state,
        response: payload,
      }
    case 'C_ERROR':
      return {
        ...state,
        response: payload,
      }
    default:
      return state
  }
}
